import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl } from "@angular/forms";
import { SensorsService } from "../../../shared/services/sensors.service";
import { Location } from "@angular/common";
@Component({
  selector: "lba-datepicker",
  templateUrl: "./change-ssid.component.html",
  styleUrls: ["./change-ssid.component.scss"],
})
export class setSsidComponent implements OnInit {
  form: FormGroup;
  isStartTime: boolean;
  ssid: string = null;
  doShowTime: boolean = false;

  now = new Date();

  modelDatePicker: NgbDateStruct;
  date: {
    year: number;
    month: number;
    day: number;
    hour: number;
    minute: number;
  };
  time = { hour: 0, minute: 0 };

  constructor(
    private activeModal: NgbActiveModal,
    private location: Location
  ) {}

  ngOnInit() {
    this.configureUI();
  }

  configureUI() {
    this.form = new FormGroup({
      ssid: new FormControl(null),
      //  'description': new FormControl(null),
    });
  }

  closeModal() {
    this.activeModal.close(this.ssid);
  }
  submit() {
    const formData = this.form.value;
    console.log("ssid 11: ", formData.ssid);
    this.ssid = formData.ssid;

    if (this.ssid != null || this.ssid !== undefined) {
      this.activeModal.close(this.ssid);
      this.cancel();
    } else {
      this.cancel;
    }
  }
  cancel() {
    this.activeModal.close(this.ssid);
    this.location.back(); // <-- go back to previous location on cancel
  }
}
